import { Component, OnInit } from '@angular/core';
import { FORMS } from '../forms';
import { FieldSet, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { UbsBlogService } from '../../services/ubs-blog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedValue } from '@urbannex/view-containers';
import { FormBuilder, FormControl } from '@angular/forms';
import { take } from 'rxjs';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-ubs-blog-article-edit',
  templateUrl: './ubs-blog-article-edit.component.html',
  styleUrls: ['./ubs-blog-article-edit.component.scss']
})
export class UbsBlogArticleEditComponent implements OnInit {
  addForm = new OfbizForm({
    formName:"EditArticleRest",
    local:true,
    formLocation:"component://content/widget/forum/BlogForms.xml",
    appContext:"content",
    layout:"SingleColumn",
    fields:this.blogService.getFields("EditArticleRest",FORMS),
    fieldSets:this.getFieldSets("EditArticleRest",FORMS),
    target:this.blogService.getTarget("EditArticleRest",FORMS),
    targets:this.blogService.getTargets("EditArticleRest",FORMS),
    titleDescriptionField:"storeName",
    idFieldName:"productStoreId",
    renderComponent:"EditStore"
  })

  title="Edit Article";
  state=null;
  target:string; // = this.setTarget(this.addForm);
  parameters:any[]=[];
  lookupSelectedValue:any;
  tempForm = this.fb.group({}); // Used to get the default value from backend
  hasValue:boolean = false;
  /**
   * Possible positions for notification toaster
   */
  positions = NbGlobalPhysicalPosition;

  constructor(private blogService:UbsBlogService,
    private route:ActivatedRoute,
    private fb:FormBuilder,
    private ofbizFormsService:OfbizFormsService,
    private toastrService: NbToastrService){

  }
  ngOnInit(): void {
    setTimeout(() => {
      console.log(this.addForm);
      let parameters = {};
      this.route.paramMap.subscribe((params) => {
        if(params.get("articleContentId")){
          parameters["blogContentId"] = params.get("blogContentId");
          parameters["articleContentId"] = params.get("articleContentId");
          console.log(parameters);
          this.populateParameters(parameters);
          this.target = "updateBlogArticle";
          this.getValue(this.addForm)
        }else if(!params.get("articleContentId")){
          parameters["blogContentId"] = params.get("blogContentId");
          this.populateParameters(parameters);
          this.target = "createBlogArticle";
          //Add parameters to addForm
          //let dataField:FormControl = this.tempForm.controls["blogContentId"];
          let valueField = this.addForm.fields.find(field => field.name === "blogContentId");
          valueField.value = parameters["blogContentId"];
          this.hasValue = true;
        }    
      })
      
    }, 100);
  }

  getFieldSets(formName:string,FORMS):FieldSet[]{
    let fieldSets = [];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    fieldSets = localForm.fieldSets;
    return fieldSets;
  }

  setTarget(addForm:OfbizForm):string{
    let target = "";
    let targets = addForm.targets? addForm.targets : null;
    if(targets != null){
      console.log({Targets:targets});
      target = targets["updateTarget"];
    }else if(this.addForm.target != null && this.addForm.target != undefined){
      console.log({"NoTARGETS":addForm.formName})
      target = this.addForm.target;
    }else{
      console.log({"NoTarget":addForm.formName})
    }
    return target
  }

  populateParameters(parameters:any){
    if(parameters != undefined){
      Object.keys(parameters).forEach(key =>{
        this.tempForm.addControl(key,new FormControl(parameters[key]));
      });
    }
  }

  openDialogContainer(e){

  }

  getValue(addForm:OfbizForm){
    let selectedValue:SelectedValue = {
      event:"edit",
      type:"",
      data:{
        formData:{
          formName:addForm.formName,
          formLocation:addForm.formLocation
        }
      }
    };
    console.log({ofbizForm:addForm});
    console.log({tempForm:this.tempForm});
    let formData = selectedValue.data.formData;
    this.ofbizFormsService.getValue(formData,this.tempForm.value,null)
    .pipe(take(1))
    .subscribe(responseData => {
      const statusCode = responseData["statusCode"];
      console.log(statusCode);
      switch (statusCode) {
        case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              //this.responseMessage = "success";
              //let formFields:OfbizField[] = this.addForm.fields;
              let dataFields:any[] = formData["fields"];
              this.parameters = dataFields;
              let titlePlaceHolder = ""
              this.addForm.fields.forEach(field => {
                console.log(field);
                let dataField = dataFields.find(element => field.name == Object.keys(element)[0]);
                if(dataField){
                  field.value = dataField[field.name];
                  if(field.name == "contentName"){
                    titlePlaceHolder = dataField[field.name];
                  }
                }
              });
              console.log({AddFormAfter:this.addForm});
              this.title = this.title+" : "+titlePlaceHolder;
              this.hasValue = true;
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    })
  }
  /**
   * 
   * @param $event Result of form submissions
   */
  submitResult(e){
    let position = this.positions.TOP_RIGHT;
    let status = "";
    if(e === "success"){
      status = "success";
      this.toastrService.show("Article successfully updated","Blog Article Update",{position, status});
    }
  }
}
